import { render, staticRenderFns } from "./FieldTransText.vue?vue&type=template&id=7847d1d9&"
import script from "./FieldTransText.vue?vue&type=script&lang=js&"
export * from "./FieldTransText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports